module.exports = __webpack_public_path__ + "static/parfume_4k-c30f51767a03d93f3a77ae8a7e3caeb0.jpg";